import { t } from "@lingui/macro"
import { NextRouter } from "next/router"
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import { goto, routeV4 } from "../../../../../_common/routing"
import {
    canGoToCategoriesV4,
    canGoToFareV4,
    canGoToGuestsV4,
    canGoToSendQuoteV4,
} from "../../ecommerce-machine/e-commerce-machine-transitions"
import { ECommerceState } from "../../ecommerce-machine/e-commerce-machine"
import { BookingStepsV4 } from "../../../../../_common/steps/booking-steps-v4"
import { NavStep } from "../../../nav-step"

export const visiblePriceConfigStepsV4 = (router: NextRouter, state: ECommerceState): NavStep<BookingStepsV4>[] => [
    {
        id: "guestsV4",
        label: t`Guest selection`,
        canGoto: () => canGoToGuestsV4(state),
        goto: () => goto(router, routeV4("")),
        completed: () => Occupancy.totalGuests(state.context.guests) > 0,
    },
    {
        id: "categoryV4",
        label: t`Suite Category`,
        canGoto: () => canGoToCategoriesV4(state),
        goto: () => goto(router, routeV4("category")),
        completed: () => !!state.context.selectedSuiteCategory,
    },
    {
        id: "fareV4",
        label: t`Fare type`,
        canGoto: () => canGoToFareV4(state),
        goto: () => goto(router, routeV4("fare")),
        completed: () => !!state.context.selectedFare,
    },
    {
        id: "send-quoteV4",
        label: t`Receive quote`,
        canGoto: () => canGoToSendQuoteV4(state),
        goto: () => goto(router, routeV4("send-quote")),
        completed: () => !!state.context.webQuoteGuestInfo,
    },
]
